import { createAsyncThunk } from '@reduxjs/toolkit';

import getDealerships from 'services/dealerships/getAllDealerships';

export const getAllDealershipsAction = createAsyncThunk('dealerships/getAll', async () => {
  const dealerships = await getDealerships();

  return { dealerships };
});
